<template>
  <section class="prompt">
    <div class="wrap">
      <h4>注意事项：</h4>
      <p>1. 以参赛团队为单位进行报名，每队指定队长1名，由队长统一报名并添加队员，队员无需重复注册。</p>
      <p>2. 参赛选手专业不限，鼓励跨学科组队，但不能跨学校组队。</p>
      <p>3. 每件作品参赛团队可由3~5名学生组成，并指定1 名学生为队长。本届赛事分为高职高专组、本科生组和研究生组，分组依据以团队中在读学历最高的成员为准。严禁参赛队伍成员重复或交叉参赛。</p>
      <p>4. 每件作品参赛队伍可指定1~2名指导教师，每位指导教师最多同时指导3支参赛队伍。</p>
      <p>5. 需上传两套作品，存档作品和评审作品，存档作品信息全面，评审作品需隐掉体现学校和导师的信息。</p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'PagePrompt'
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
